import type { RouteRecordRaw } from 'vue-router';

const operatorChildRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: 'OperatorOverview',
    component: () => import('@/features/operator/overview/pages/OverviewPage.vue'),
  },
  {
    path: 'ops',
    name: 'OperatorOps',
    component: () => import('@/features/operator/ops/pages/OpsDashboardPage.vue'),
  },
  {
    path: 'tenants',
    name: 'OperatorTenants',
    component: () => import('@/features/operator/tenants/pages/TenantsPage.vue'),
  },
  {
    path: 'trial-applications',
    name: 'OperatorTrialApplications',
    component: () => import('@/features/operator/trial/pages/TrialApplicationsPage.vue'),
  },
  {
    path: 'plans',
    name: 'OperatorPlans',
    component: () => import('@/features/operator/plans/pages/PlansPage.vue'),
  },
  {
    path: 'certification-standards',
    name: 'OperatorCertificationStandards',
    component: () => import('@/features/operator/certification-standard/pages/CertificationStandardPage.vue'),
  },
  {
    path: 'usage',
    name: 'OperatorUsage',
    component: () => import('@/features/operator/usage/pages/UsagePage.vue'),
  },
  {
    path: 'api-platform',
    name: 'OperatorApiPlatform',
    component: () => import('@/features/operator/api-platform/pages/ApiPlatformPage.vue'),
  },
  {
    path: 'api-request-logs',
    name: 'OperatorApiRequestLogs',
    component: () => import('@/features/operator/api-platform/pages/ApiRequestLogsPage.vue'),
  },
  {
    path: 'ai',
    name: 'OperatorAi',
    component: () => import('@/features/operator/ai/pages/AiPlatformPage.vue'),
  },
  {
    path: 'billing',
    name: 'OperatorBilling',
    component: () => import('@/features/operator/billing/pages/BillingPage.vue'),
  },
  {
    path: 'billing/enhancements',
    name: 'OperatorBillingEnhancements',
    component: () =>
      import('@/features/operator/billing/pages/BillingEnhancementsPage.vue'),
  },
  {
    path: 'feature-flags',
    name: 'OperatorFeatureFlags',
    component: () => import('@/features/operator/feature-flags/pages/FeatureFlagsPage.vue'),
  },
  {
    path: 'backups',
    name: 'OperatorBackups',
    component: () => import('@/features/operator/backups/pages/BackupsPage.vue'),
  },
  {
    path: 'report-demo',
    name: 'OperatorReportDemo',
    component: () => import('@/features/operator/reports/pages/ReportDemoPage.vue'),
  },
  {
    path: 'import-demo',
    name: 'OperatorImportDemo',
    component: () => import('@/features/operator/demos/pages/ImportDemoPage.vue'),
  },
  {
    path: 'audit-logs',
    name: 'OperatorAuditLogs',
    component: () => import('@/features/operator/platform-logs/pages/AuditLogsPage.vue'),
  },
  {
    path: 'webhook-logs',
    name: 'OperatorWebhookLogs',
    component: () => import('@/features/operator/platform-logs/pages/WebhookLogsPage.vue'),
  },
  {
    path: 'email-logs',
    name: 'OperatorEmailLogs',
    component: () => import('@/features/operator/platform-logs/pages/EmailLogsPage.vue'),
  },
  {
    path: 'report-logs',
    name: 'OperatorReportLogs',
    component: () => import('@/features/operator/platform-logs/pages/ReportLogsPage.vue'),
  },
  {
    path: 'outbox',
    name: 'OperatorOutbox',
    component: () => import('@/features/operator/outbox/pages/OutboxPage.vue'),
  },
  {
    path: 'email-templates',
    name: 'OperatorEmailTemplates',
    component: () => import('@/features/operator/email/pages/EmailTemplatesPage.vue'),
  },
  {
    path: 'user-feedbacks',
    name: 'OperatorUserFeedbacks',
    component: () => import('@/features/operator/feedback/pages/UserFeedbacksPage.vue'),
  },
  {
    path: 'notifications/send',
    name: 'OperatorNotificationSend',
    component: () => import('@/features/operator/notifications/pages/OperatorNotificationSendPage.vue'),
  },
  {
    path: 'notifications/history',
    name: 'OperatorNotificationHistory',
    component: () => import('@/features/operator/notifications/pages/OperatorNotificationHistoryPage.vue'),
  },
  {
    path: 'notifications',
    redirect: '/operator/notifications/send',
  },
  {
    path: 'settings',
    name: 'OperatorSettings',
    component: () => import('@/features/operator/settings/pages/SystemSettingsPage.vue'),
  },
];

function redirectLegacyManagerPath(path: string) {
  const rest = path.replace(/^\/manager\/?/, '');
  return rest ? `/operator/${rest}` : '/operator';
}

export const operatorRoutes: RouteRecordRaw[] = [
  {
    path: '/operator',
    component: () => import('@/features/operator/shell/OperatorLayout.vue'),
    meta: { requiresAuth: true, requiresOperator: true },
    children: operatorChildRoutes,
  },
  {
    path: '/manager/:pathMatch(.*)*',
    redirect: to => redirectLegacyManagerPath(to.path),
  },
  {
    path: '/manager',
    redirect: '/operator',
  },
  {
    path: '/operations',
    redirect: '/operator',
  },
];
